import PriceSchemesModal from './PriceSchemesModal';
export default PriceSchemesModal;
